
const initialState = {
    isLoading: false,
    exploreList: [],
    error: null,
    paymentStatus:{}
  };
  

  const ExploreReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'FETCH_DATA_REQUEST':
        return {
          ...state,
          isLoading: true,
          error: null
        };
      case 'FETCH_DATA_SUCCESS':
        return {
          ...state,
          isLoading: false,
          exploreList: action.payload,
          error: null
        };
      case 'FETCH_DATA_FAILURE':
        return {
          ...state,
          isLoading: false,
          exploreList: [],
          error: action.payload
        };
        case 'PAYMENT_REQUEST':
      return {
        ...state,
        isLoading: false,
      };
    case 'PAYMENT_SUCCESS':
      return {
        ...state,
        isLoading: false,
        paymentStatus:action.payload
      };
    case 'PAYMENT_FAILURE':
      return {
        ...state,
        isLoading:false,
        error:action.payload
      };
        case 'Reset_State':
          return {
            ...state,
            isLoading: false,
            exploreList: [],
          }
      default:
        return state;
    }
  };
  
  export default ExploreReducer;
  